module.exports = __webpack_public_path__ + "media/images/icons/circle-6cbe5d9c89ab995358f111c7d315debc.svg";